import type { IconData } from '@stacksjs/iconify-core'

export const rectangleF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3 .565h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-10a3 3 0 0 1 3-3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default rectangleF
